import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  Feather, Smartphone, Zap, Heart, Star,
  Camera, Mail, Clock, Palette, QrCode, ChevronDown, Send,
} from 'lucide-react';
import Footer from '../components/Footer';
import SEO from '../shared/seo/SEO';
import '../styles/home.css';

const FEATURES_VISIBLE = [
  {
    Icon: Feather,
    title: '12+ Красиви Шаблона',
    desc: 'Професионално проектирани шаблони за сватбен уебсайт — от класически елегантни до модерни минималистични. Всеки шаблон е напълно персонализируем и готов да разкаже вашата любовна история.',
  },
  {
    Icon: Send,
    title: 'Дигитални Покани за Сватба',
    desc: 'Изпратете онлайн покани за сватба чрез имейл, Viber, Messenger или с QR код. Вашият сватбен сайт служи като дигитална покана — гостите виждат цялата информация и потвърждават онлайн.',
  },
  {
    Icon: Zap,
    title: 'Лесен Конструктор',
    desc: 'Създайте своя сватбен уебсайт за минути без технически умения. Плъзгайте и пускайте секции, добавяйте съдържание и публикувайте моментално.',
  },
];

const FEATURES_HIDDEN = [
  {
    Icon: Camera,
    title: 'Галерия с Качване от Гости',
    desc: 'Вашите гости могат да качват снимки от сватбата директно в галерията на сайта. Създайте онлайн сватбен албум с хиляди снимки, качени от всички присъстващи.',
  },
  {
    Icon: Mail,
    title: 'RSVP Имейли',
    desc: 'Получавайте потвърждения за присъствие директно по имейл. Вашите гости могат да RSVP-нат онлайн с едно кликване — без излишна хартия и обаждания.',
  },
  {
    Icon: QrCode,
    title: 'QR Код за Покани',
    desc: 'Вградете QR код към вашия сватбен уебсайт в хартиените покани. Гостите сканират с телефона и веднага виждат цялата информация за сватбата.',
  },
  {
    Icon: Clock,
    title: 'Таймлайн и Броене',
    desc: 'Разкажете вашата история с интерактивен таймлайн на любовта и добавете броене до сватбения ден. Създайте вълнение сред гостите си с всеки изминал ден.',
  },
  {
    Icon: Palette,
    title: 'Пълна Персонализация',
    desc: 'Сменяйте цветове, шрифтове, фонове и оформление с няколко клика. Вашият сватбен сайт трябва да изглежда точно както вие искате — без да пишете код.',
  },
  {
    Icon: Smartphone,
    title: 'Мобилен и Бърз',
    desc: 'Всеки сватбен уебсайт е оптимизиран за телефони и таблети. Вашите гости ще имат перфектно изживяване на всяко устройство.',
  },
];

const FAQS = [
  {
    q: 'Какво е сватбен уебсайт и за какво служи?',
    a: 'Сватбеният уебсайт е онлайн платформа, която съдържа цялата информация за вашата сватба — дата, място, програма, галерия снимки, RSVP потвърждения и таймлайн на любовната ви история. Гостите могат да го посетят по всяко време от телефона или компютъра си.',
  },
  {
    q: 'Могат ли гостите да качват снимки от сватбата?',
    a: 'Да! Това е една от най-популярните ни функции. Всеки гост може да сканира QR кода от поканaта или да посети сайта и да качи своите снимки от сватбения ден. Така всички споделят и запазват спомените.',
  },
  {
    q: 'Как да направя сватбен уебсайт?',
    a: 'Регистрирайте се безплатно, изберете шаблон и започнете да добавяте вашата информация — дата, локация, таймлайн, галерия. Нашият интуитивен конструктор ви води стъпка по стъпка. Публикувате сайта с едно кликване.',
  },
  {
    q: 'Как работи RSVP онлайн?',
    a: 'Вашите гости влизат в сватбения уебсайт и кликват върху RSVP бутона. Попълват име и брой гости и потвърждението пристига директно във вашия имейл. Без телефонни обаждания и хартиени списъци.',
  },
  {
    q: 'Мога ли да добавя таймлайн на любовната история?',
    a: 'Да, нашият конструктор за таймлайн ви позволява да добавите ключови моменти от вашата любовна история — запознанство, първа среща, предложение и други. Всеки момент може да включва снимка, дата и описание.',
  },
  {
    q: 'Подходящ ли е за български сватби?',
    a: 'Напълно! Платформата е създадена от българи за българския пазар. Цялото съдържание е на български език, поддържа български дати и формати, и е оптимизирано за българските сватбени традиции.',
  },
  {
    q: 'Как да добавя QR код към хартиените покани?',
    a: 'Всеки сватбен уебсайт получава уникален QR код, който можете да изтеглите и отпечатате върху хартиените покани. Гостите сканират с телефона и отиват директно на вашия сайт.',
  },
  {
    q: 'Мога ли да променям дизайна след публикуване?',
    a: 'Да, можете да променяте всичко по всяко време — цветове, шрифтове, секции, снимки и текст. Промените влизат в сила веднага след запазване.',
  },
  {
    q: 'Какви шаблони са налични?',
    a: 'Предлагаме над 12 различни шаблона в 4 категории — класически, модерни, минималистични и живи/цветни. Всеки шаблон има уникален стил и може да бъде напълно персонализиран според вашия вкус.',
  },
  {
    q: 'Мога ли да изпратя дигитални покани за сватба чрез платформата?',
    a: 'Да! Вашият сватбен уебсайт се превръща в дигитална покана за сватба. Споделете линка или QR кода с гостите чрез имейл, Messenger, Viber или го отпечатайте върху хартиените покани. Гостите виждат онлайн поканата за сватба с цялата информация и могат да RSVP-нат директно от телефона си.',
  },
];

function Home() {
  const { currentUser } = useAuth();
  const [showAllFeatures, setShowAllFeatures] = useState(false);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <main className="home">
      <SEO
        title="Сватбен Уебсайт и Дигитални Покани за Сватба — Нашата Сватба"
        description="Създайте своя сватбен уебсайт и дигитални покани за сватба с Нашата Сватба. Онлайн покани за сватба с QR код, RSVP имейли, галерия снимки от гости, таймлайн и броене до деня. Безплатен сватбен сайт за български двойки."
        ogTitle="Сватбен Уебсайт и Дигитални Покани за Сватба — Нашата Сватба"
        ogDescription="Създайте впечатляващ сватбен уебсайт и дигитални покани за сватба. Онлайн покани с QR код, RSVP, галерия за гости и броене. Безплатен сватбен сайт за български двойки."
        canonical="https://www.nashatasvatba.in/"
      />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          'name': 'Нашата Сватба',
          'alternateName': 'Nashata Svatba',
          'url': 'https://www.nashatasvatba.in/',
          'description': 'Платформа за създаване на сватбени уебсайтове за български двойки',
          'inLanguage': 'bg-BG',
          'address': {
            '@type': 'PostalAddress',
            'addressLocality': 'Враца',
            'addressCountry': 'България',
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          'name': 'Nashata Svatba',
          'alternateName': 'Нашата Сватба',
          'url': 'https://www.nashatasvatba.in/',
          'logo': 'https://www.nashatasvatba.in/logo.png',
          'contactPoint': {
            '@type': 'ContactPoint',
            'telephone': '+359-87-677-5346',
            'contactType': 'customer service',
            'availableLanguage': ['Bulgarian'],
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>

      <section className="home-hero" aria-label="Главна секция">
        <div className="home-hero-inner">
          <div className="home-hero-content">
            <span className="home-hero-eyebrow">Nashata Svatba — Сватбен Уебсайт и Дигитални Покани</span>
            <h1 className="home-hero-title">
              Вашият <em>Сватбен Уебсайт</em> и Дигитални Покани
            </h1>
            <p className="home-hero-body">
              Създайте своя сватбен уебсайт и дигитални покани за сватба с Нашата Сватба. Красиви шаблони за сватбен сайт, онлайн покани за сватба с QR код, галерия за снимки от гостите, RSVP потвърждения по имейл, таймлайн на любовта и броене до големия ден. Платформата е изцяло на български език и създадена за българските двойки.
            </p>

            <div className="home-hero-actions">
              {currentUser ? (
                <Link to="/dashboard" className="btn btn-primary btn-lg">
                  Към Таблото
                </Link>
              ) : (
                <>
                  <Link to="/register" className="btn btn-primary btn-lg">
                    Създайте Сватбен Сайт
                  </Link>
                  <Link to="/login" className="btn btn-secondary btn-lg">
                    Онлайн Покани
                  </Link>
                </>
              )}
            </div>
          </div>

          <div className="home-hero-image">
            <img
              src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0"
              alt="Красива сватбена декорация и букет - идеално за сватбен уебсайт"
              loading="eager"
            />
          </div>
        </div>
      </section>

      <section className="home-section home-section-alt" id="features" aria-label="Функции на платформата">
        <header>
          <h2 className="home-section-title">
            Вашият Сватбен Уебсайт с Дигитални Покани за Сватба
          </h2>
          <p className="home-section-subtitle">
            Създайте сватбен сайт и онлайн покани за сватба — всичко от което се нуждаете за вашата сватба на едно място. Дигитални покани с QR код, сватбена галерия, RSVP онлайн, таймлайн и броене.
          </p>
        </header>

        <div className="home-features">
          {FEATURES_VISIBLE.map(({ Icon, title, desc }, i) => (
            <article key={i} className="card card-padding card-hover">
              <div className="home-feature-icon">
                <Icon size={28} />
              </div>
              <h3 className="home-feature-title">{title}</h3>
              <p className="home-feature-desc">{desc}</p>
            </article>
          ))}
        </div>

        {showAllFeatures && (
          <div className="home-features home-features-hidden">
            {FEATURES_HIDDEN.map(({ Icon, title, desc }, i) => (
              <article key={i} className="card card-padding card-hover">
                <div className="home-feature-icon">
                  <Icon size={28} />
                </div>
                <h3 className="home-feature-title">{title}</h3>
                <p className="home-feature-desc">{desc}</p>
              </article>
            ))}
          </div>
        )}

        <div className="home-features-toggle">
          <button
            className="btn btn-ghost btn-lg"
            onClick={() => setShowAllFeatures(prev => !prev)}
          >
            {showAllFeatures ? 'Покажи по-малко' : 'Вижте всички функции'}
            <ChevronDown
              size={18}
              style={{
                marginLeft: '6px',
                transition: 'transform 0.2s',
                transform: showAllFeatures ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
          </button>
        </div>
      </section>

      <section className="home-section" aria-label="Отзиви">
        <div className="home-testimonial-card">
          <h2 className="home-section-title">Какво Казват Двойките</h2>
          <figure className="home-testimonial">
            <div className="home-testimonial-stars" aria-label="5 от 5 звезди">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} fill="currentColor" />
              ))}
            </div>
            <blockquote className="home-testimonial-quote">
              "Създаването на нашия сватбен уебсайт беше толкова лесно и забавно! Шаблоните са красиви, а възможностите за персонализация са безкрайни. Гостите ни обожават галерията за качване на снимки!"
            </blockquote>
            <figcaption>
              <div className="home-testimonial-author">
                <div className="home-testimonial-avatar">
                  <Heart size={16} />
                </div>
                <div>
                  <cite>Сара и Михаил</cite>
                  <span>Щастливи младоженци</span>
                </div>
              </div>
            </figcaption>
          </figure>
        </div>
      </section>

      <section className="home-section" aria-label="Призив за действие">
        <div className="home-cta">
          <h2 className="home-cta-title">
            Създайте Вашия Сватбен Уебсайт и Дигитални Покани Сега
          </h2>
          <p className="home-cta-body">
            Присъединете се към хиляди български двойки, които вече създадоха своя перфектен сватбен сайт и онлайн покани за сватба с нас. Лесно и красиво.
          </p>
          <Link to="/register" className="btn btn-dark btn-xl">
            Създайте Сватбен Сайт
          </Link>
        </div>
      </section>

      <section className="home-faq-section" aria-label="Често задавани въпроси">
        <header>
          <h2 className="home-section-title">
            Често Задавани Въпроси за Сватбен Сайт и Дигитални Покани
          </h2>
          <p className="home-section-subtitle">
            Всичко, което трябва да знаете за създаването на сватбен уебсайт, сватбен сайт, онлайн покани за сватба и дигитални покани в България.
          </p>
        </header>
        <div className="home-faqs">
          {FAQS.map((faq, i) => (
            <details key={i} className="home-faq-item">
              <summary className="home-faq-question">
                <h3>{faq.q}</h3>
              </summary>
              <p className="home-faq-answer">{faq.a}</p>
            </details>
          ))}
        </div>
      </section>

      <Footer />
    </main>
  );
}

export default Home;
